// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LightboxImage-module--wrapper--2l4kE","image":"LightboxImage-module--image--2H3sm"};